<template>
  <div class="row">
    <div class="col-md-6">
      <Print :items="items" :data="data" :setting="setting" />
    </div>
    <div class="col-md-3">
      <PrintThermal :items="items" :data="data" :setting="setting" />
    </div>

    <!-- PDF -->
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="true"
      :paginate-elements-by-height="1400" :filename="
        'struk-apotek-' + data.patient_name == ''
          ? data.code
          : data.patient_name
      " :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="portrait"
      pdf-content-width="800px" @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)" ref="html2Pdf">
      <section slot="pdf-content">
        <Print :items="items" :data="data" :setting="setting" />
        <!-- <PrintThermal :items="items" :data="data" :setting="setting" /> -->
      </section>
    </vue-html2pdf>

    <div class="col-md">
      <b-badge :variant="statusVariant" class="d-block p-2 mb-2">{{ statusLabel }}</b-badge>
      <b-button squared class="mt-2" size="sm" variant="primary" @click="btnPrintOnClick">Print</b-button>
      <b-button squared :class="'d-block mt-2'" size="sm" variant="warning" @click="btnPrintThermalOnClick">Print
        Thermal</b-button>
      <b-button squared :class="'d-block mt-2'" size="sm" variant="info" @click="btnDownloadOnClick">Download</b-button>
      <!-- <b-button
          squared
          :class="'d-block mt-2'"
          size="sm"
          variant="success"
          @click="$router.push('/pharmacy/cashier/' + data.id)"
        >Edit Order</b-button> -->
      <b-button squared :class="'d-block mt-2'" size="sm" variant="success"
        @click="$router.push('/pharmacy/cashier')">Tambah Baru</b-button>
      <b-button v-if="canReturn" squared class="d-block mt-2" size="sm" variant="danger" @click="openReturn">Ajukan Retur</b-button>
      <b-button v-if="transaction.order && transaction.order.dispensing_status === 'pending_verification'" squared class="d-block mt-2" size="sm" variant="primary" @click="verifyDispensing">Verifikasi Apoteker</b-button>
      <b-button squared class="d-block mt-2" size="sm" variant="outline-primary" @click="openLabels">Label Obat</b-button>
      <div v-for="ret in transaction.returns || []" :key="ret.id" class="border rounded p-2 mt-2 small">
        <b>{{ ret.return_number }}</b><br>{{ ret.status }} · {{ currency(ret.total_amount) }}
        <div v-if="ret.status === 'pending'" class="mt-1">
          <b-button size="sm" variant="success" @click="reviewReturn(ret, 'approved')">Setujui</b-button>
          <b-button size="sm" variant="outline-danger" @click="reviewReturn(ret, 'rejected')">Tolak</b-button>
        </div>
      </div>
    </div>
    <PrintThermalReal :items="items" :data="data" :setting="setting" class="d-none" />

    <b-modal id="pharmacy-return-modal" title="Ajukan Retur Penjualan" ok-title="Ajukan" cancel-title="Batal" @ok.prevent="submitReturn">
      <b-form-group label="Alasan"><b-form-select v-model="returnForm.reason_code" :options="returnReasons" /></b-form-group>
      <b-form-group label="Keterangan"><b-form-textarea v-model="returnForm.reason" rows="2" /></b-form-group>
      <b-form-group label="Disposition stok"><b-form-select v-model="returnForm.stock_disposition" :options="dispositions" /></b-form-group>
      <div v-for="detail in transaction.details || []" :key="detail.id" class="border rounded p-2 mb-2">
        <strong>{{ detail.medicine_name }}</strong>
        <div v-for="batch in detail.batch_allocations" :key="batch.id" class="row align-items-center mt-1">
          <div class="col-7"><b-form-checkbox v-model="selectedBatches" :value="batch.id">Batch {{ batch.batch_no || '-' }} · maks {{ availableReturn(batch) }}</b-form-checkbox></div>
          <div class="col-5"><b-form-input v-model.number="returnQuantities[batch.id]" type="number" min="0" :max="availableReturn(batch)" step="0.0001" /></div>
        </div>
      </div>
    </b-modal>
    <b-modal id="pharmacy-label-modal" title="Label Obat & Racikan" size="lg" hide-footer>
      <div id="pharmacy-label-print">
        <div v-for="label in labels" :key="label.id" class="border rounded p-3 mb-3">
          <strong>{{ label.medicine_name }}</strong><span class="float-right">{{ label.order_code }}</span>
          <div>{{ label.patient_name }} · {{ label.doctor_name }}</div>
          <div class="h5 my-2">{{ label.signa || "Aturan pakai belum diisi" }}</div>
          <small>{{ label.usage_instruction }} · {{ label.dispensed_quantity }} {{ label.uom_name || "unit" }} · Batch {{ label.batch_numbers || "-" }} · BUD/ED {{ label.beyond_use_date || "-" }}</small>
          <div class="mt-2 font-weight-bold">{{ label.barcode_value }}</div>
        </div>
      </div>
      <b-button block variant="primary" @click="$htmlToPaper('pharmacy-label-print')">Cetak Label</b-button>
    </b-modal>
  </div>
</template>

<script>

// components
import Print from "@/component/pharmacy/pharmacy-orders/Print.vue";
import PrintThermal from "@/component/pharmacy/pharmacy-orders/PrintThermal.vue";
import PrintThermalReal from "@/component/pharmacy/pharmacy-orders/PrintThermalReal.vue";

import module from "@/core/modules/CrudModule.js";
import VueHtml2pdf from "vue-html2pdf";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service.js";
import Swal from "sweetalert2";

export default {
  components: {
    VueHtml2pdf,
    Print,
    PrintThermal,
    PrintThermalReal,
  },

  data() {
    return {
      // Data
      data: {},
      // Table Items
      items: [],
      setting: {},
      transaction: {},
      labels: [],
      selectedBatches: [],
      returnQuantities: {},
      returnForm: { return_type: "refund", reason_code: "patient_return", reason: "", stock_disposition: "quarantine" },
      returnReasons: [{value:"patient_return",text:"Retur pasien"},{value:"wrong_item",text:"Salah obat"},{value:"quality_issue",text:"Masalah mutu"},{value:"correction",text:"Koreksi transaksi"}],
      dispositions: [{value:"quarantine",text:"Karantina untuk pemeriksaan"},{value:"restock",text:"Kembalikan ke stok"},{value:"destroy",text:"Pemusnahan"}],
    };
  },

  methods: {
    async get() {
      this.data = await module.get(
        `pharmacy-payments/get-by-order/${this.$route.params.id}`
      );
      this.items = this.data.order_details;
      await this.loadTransaction();
    },

    async loadTransaction() {
      const response = await ApiService.get(`pharmacy-sales/${this.$route.params.id}/transaction`);
      this.transaction = response.data.data || {};
    },

    currency(value) { return `Rp ${Number(value || 0).toLocaleString("id-ID")}`; },
    availableReturn(batch) { return Math.max(0, Number(batch.quantity) - Number(batch.returned_quantity)); },
    openReturn() {
      this.selectedBatches=[];this.returnQuantities={};
      (this.transaction.details || []).forEach(detail => detail.batch_allocations.forEach(batch => { this.$set(this.returnQuantities,batch.id,this.availableReturn(batch)); }));
      this.$bvModal.show("pharmacy-return-modal");
    },
    async submitReturn() {
      const items=this.selectedBatches.map(id=>({batch_allocation_id:id,quantity:Number(this.returnQuantities[id]||0)})).filter(row=>row.quantity>0);
      if(!items.length || this.returnForm.reason.length<8){Swal.fire("Data belum lengkap","Pilih batch dan isi alasan minimal 8 karakter.","warning");return;}
      await ApiService.post(`pharmacy-sales/${this.$route.params.id}/returns`,{...this.returnForm,items});
      this.$bvModal.hide("pharmacy-return-modal");await this.loadTransaction();Swal.fire("Diajukan","Retur menunggu persetujuan petugas lain.","success");
    },
    async reviewReturn(ret,decision) {
      const result=await Swal.fire({title:decision==="approved"?"Setujui retur?":"Tolak retur?",input:"text",inputLabel:"Catatan review",showCancelButton:true});
      if(result.dismiss)return;
      try{await ApiService.post(`pharmacy-sales/returns/${ret.id}/review`,{decision,review_notes:result.value||"Reviewed"});await this.loadTransaction();Swal.fire("Tersimpan","Keputusan retur telah diproses.","success");}
      catch(error){Swal.fire("Tidak dapat diproses",(error.response&&error.response.data&&error.response.data.message)||"Periksa kewenangan reviewer.","error");}
    },
    async verifyDispensing() {
      const result=await Swal.fire({title:"Verifikasi dispensing",input:"textarea",inputLabel:"Catatan apoteker",showCancelButton:true,confirmButtonText:"Verifikasi"});
      if(result.dismiss)return;
      await ApiService.post(`pharmacy-sales/${this.$route.params.id}/verify`,{decision:"verified",notes:result.value||"Telah diverifikasi"});await this.loadTransaction();
    },
    async openLabels() {
      const response=await ApiService.get(`pharmacy-sales/${this.$route.params.id}/labels`);
      this.labels=response.data.data||[];this.$bvModal.show("pharmacy-label-modal");
    },

    async getSetting() {
      this.setting = await module.get("website-settings/get-default");
      if (this.setting == null) {
        this.setting = {
          address:
            "Jl. Kramat 6 No.11, RT.2/RW.1, Kenari, Kec. Senen, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10430",
          phone: "(021) 3909333",
        };
      }
    },

    btnPrintOnClick() {
      this.$htmlToPaper("print-pharmacy");
    },

    btnPrintThermalOnClick() {
      this.$htmlToPaper("print-pharmacy-thermal");
    },

    btnDownloadOnClick() {
      this.$refs.html2Pdf.generatePdf();
    },

    onProgress($event) {
      console.log("onProgress", $event);
    },

    hasStartedGeneration() {
      console.log("hasStartedGeneration");
    },

    hasGenerated($event) {
      console.log("hasGenerated", $event);
    },
  },

  computed: {
    canReturn(){return this.transaction.order && !["void","refunded"].includes(this.transaction.order.workflow_status);},
    statusLabel(){return this.transaction.order ? `${this.transaction.order.workflow_status || "completed"} · ${this.transaction.order.dispensing_status || "dispensed"}` : "Memuat status";},
    statusVariant(){return this.transaction.order && ["void","refunded"].includes(this.transaction.order.workflow_status)?"danger":"success";},
  },

  mounted() {
    let conf = JSON.parse(localStorage.getItem("user"));
    this.setting = {
      address: conf.address,
      phone: conf.phone,
    };
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Apotek", route: "" },
      { title: "Penjualan", route: "/pharmacy/sales" },
      { title: "Detail Penjualan" },
    ]);
    // Get
    this.get();
    // this.getSetting();
  },
};
</script>

<style></style>
